module.exports = __webpack_public_path__ + "static/img/banner.5421bd3e.png";